var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "none",
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#627790",
    strokeMiterlimit: 10,
    strokeWidth: 1.2,
    d: "M8.316 1.437a.2.2 0 01.368 0l1.942 4.603a.2.2 0 00.162.121l4.781.521a.2.2 0 01.116.345l-3.59 3.39a.2.2 0 00-.058.185l1.007 4.949a.2.2 0 01-.3.21l-4.14-2.521a.2.2 0 00-.208 0l-4.14 2.521a.2.2 0 01-.3-.21l1.007-4.95a.2.2 0 00-.058-.185l-3.59-3.39a.2.2 0 01.116-.344l4.78-.52a.2.2 0 00.163-.122l1.942-4.603z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star-icon.4498ee005acfcfd819afbdf31c2c4320.svg";
export { ForwardRef as ReactComponent };